import {Component} from 'panel';
import {registerMPElement} from 'common/util/register-element';

import template from './index.jade';

const NUM_PARTICLES = 100;

// simple random number helper
const rand = (a, b) => a + Math.random() * (b - a);

interface SnowParticle {
  x: number;
  y: number;
  vx: number;
  vy: number;
  opacity: number;
  radius: number;
}

class FestiveModeHeaderAnim extends Component<{}> {
  private ctx: CanvasRenderingContext2D;
  private animCanvas: HTMLCanvasElement;
  private rafId: number;
  private particles: SnowParticle[];
  private width: number;
  private height: number;
  private mouseXWind = 0;

  get config() {
    return {
      template,
      helpers: {},
    };
  }

  connectedCallback() {
    super.connectedCallback();

    // this bound since they are callbacks
    this.renderTick = this.renderTick.bind(this);
    this.updateSize = this.updateSize.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);

    window.addEventListener(`resize`, this.updateSize);
    document.body.addEventListener(`mousemove`, this.handleMouseMove);

    this.animCanvas = this.el.querySelector(`canvas`);
    this.ctx = this.animCanvas.getContext(`2d`);
    this.updateSize();
    this.generateParticles();
    this.renderTick();
  }

  disconnectedCallback() {
    window.removeEventListener(`resize`, this.updateSize);
    document.body.removeEventListener(`mousemove`, this.handleMouseMove);
    cancelAnimationFrame(this.rafId);
  }

  updateSize() {
    this.width = this.animCanvas.width = this.animCanvas.clientWidth;
    this.height = this.animCanvas.height = this.animCanvas.clientHeight;
  }

  handleMouseMove(ev: MouseEvent) {
    this.mouseXWind = ev.clientX / this.width - 0.5;
  }

  generateParticles() {
    this.particles = [];
    for (let i = 0; i < NUM_PARTICLES; i++) {
      this.particles.push(this.makeParticle());
    }
  }

  makeParticle(): SnowParticle {
    return {
      x: rand(0, this.width),
      y: rand(0, -this.height),
      vy: rand(0.1, 0.5),
      vx: rand(-0.5, 0.5),
      radius: rand(1, 3),
      opacity: rand(0.1, 0.5),
    };
  }

  renderTick() {
    const ctx = this.ctx;
    ctx.clearRect(0, 0, this.width, this.height);
    ctx.fillStyle = `#fff`;

    for (const particle of this.particles) {
      particle.y += particle.vy;
      particle.x += particle.vx + this.mouseXWind;

      ctx.globalAlpha = particle.opacity;
      ctx.beginPath();
      ctx.arc(particle.x, particle.y, particle.radius, 0, Math.PI * 2);
      ctx.closePath();
      ctx.fill();

      if (particle.y > this.height) {
        Object.assign(particle, this.makeParticle());
      }
    }

    this.rafId = requestAnimationFrame(this.renderTick);
  }
}

registerMPElement(`mp-festive-mode-header-anim`, FestiveModeHeaderAnim);
